<template>
    <div>
        <textarea id="editor" placeholder="Type something awesome!"></textarea>
    </div>
</template>

<script>

    import ClassicEditor from 'tuk-ckeditor5-classic'
    import UploadAdapter from '../plugins/UploadAdapter'

    export default {
        name: 'CKEditorComponent',
        props: {
            value: {
                type: String
            },
            height: {
                type: String,
                default: '90px',
            },
        },
        data() {
            return {
                editor: null
            }
        },

        watch: {
            value: function (newVal, oldVal) {
                if (newVal === oldVal)
                    return
                if (newVal === this.editor.getData())
                    return

                this.editor.setData(this.value)
            }
        },

        mounted() {
            ClassicEditor.defaultConfig = {
                toolbar: {
                    items: [
                        'bold',
                        'italic',
                        'custom_heading',
                        'link',
                        'imageUpload',
                        'blockQuote',
                        'bulletedList',
                        'numberedList',
                        //'insertTable',
                        //'mediaEmbed',
                        'undo',
                        'redo',
                        // 'alignment',
                        'show_tools',
                    ]
                },
                /*      image: {
                          toolbar: [
                              'imageStyle:full',
                              'imageStyle:side',
                              '|',
                              'imageTextAlternative'
                          ]
                      },
                      table: {
                          contentToolbar: [
                              'tableColumn',
                              'tableRow',
                              'mergeTableCells'
                          ]
                      },
                      */
                language: 'en',
            }

            ClassicEditor.create(document.querySelector('#editor'), {
                mention: {
                    feeds: [
                        {
                            marker: '@',
                            feed: (queryText) => {
                                // As an example of an asynchronous action, return a promise
                                // that resolves after a 100ms timeout.
                                // This can be a server request or any sort of delayed action.
                                return new Promise(resolve => {
                                    axios.get(`/get-users?query=${queryText}`, {
                                        params: {username: window.auth.username}
                                    }).then(response => {
                                        let users = response.data.map(user => {
                                            return {
                                                id: '@' + user.username,
                                                userId: user.id,
                                                name: '',
                                                link: '/@' + user.username,
                                            }
                                        })

                                        const itemsToDisplay = users
                                            // Filter out the full list of all items to only those matching the query text.
                                            .filter(isItemMatching)
                                            // Return 10 items max - needed for generic queries when the list may contain hundreds of elements.
                                            .slice(0, 10)
                                        resolve(itemsToDisplay)
                                    })
                                })

                                // Filtering function - it uses `name` and `username` properties of an item to find a match.
                                function isItemMatching(item) {
                                    // Make the search case-insensitive.
                                    const searchString = queryText.toLowerCase()

                                    // Include an item in the search results if name or username includes the current user input.
                                    return (
                                        // item.name.toLowerCase().includes(searchString) ||
                                        item.id.toLowerCase().includes(searchString)
                                    )
                                }
                            },
                            itemRenderer: (item) => {
                                const itemElement = document.createElement('span')

                                itemElement.classList.add('custom-item')
                                itemElement.id = `mention-list-item-id-${item.userId}`
                                itemElement.textContent = `${item.name} `

                                const usernameElement = document.createElement('span')

                                usernameElement.classList.add('custom-item-username')
                                usernameElement.textContent = item.id

                                itemElement.appendChild(usernameElement)

                                return itemElement
                            },
                            // minimumCharacters: 1
                        }
                    ]
                }
            }).then(editor => {
                this.editor = editor
                this.editor.setData(this.value)

                this.editor.plugins.get('FileRepository').createUploadAdapter = (loader) => {
                    return new UploadAdapter(loader)
                }

                this.editor.model.document.on('change', () => {
                    this.$emit('input', editor.getData())
                })
            }).catch(error => {
                console.error(error)
            })
        },
        destroyed() {
            this.editor.destroy()
        }
    }
</script>

<style>
    .show-tools {
        margin-left: auto !important;
    }

    .ck-editor__editable_inline {
        min-height: 250px;
    }

    .ck.ck-editor__editable > .ck-placeholder::before {
        color: #c0c4cc;
        font-size: 15px
    }
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/CKEditor.vue